import React from 'react';
import { FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt, FaWifi, FaSwimmingPool, FaUtensils } from 'react-icons/fa';

const Footer: React.FC = () => {
    return (
        <footer className="bg-gray-900 text-white">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Brand Section */}
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-xl font-bold text-primary">Sunrise Agri Resorts</h3>
                            <p className="text-sm text-gray-400">Experience Nature's Luxury</p>
                        </div>
                        <p className="text-gray-300 text-sm leading-relaxed">
                            Escape to tranquility at our beautiful agri resort, where modern comfort meets natural beauty.
                        </p>
                    </div>

                    {/* Contact Info */}
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-primary">Contact Us</h4>
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3">
                                <FaMapMarkerAlt className="text-primary flex-shrink-0" />
                                <span className="text-gray-300 text-sm">Bharthapuram (vill), bowdara(po), s.kota, Andhra Pradesh 535145, India</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaPhone className="text-primary flex-shrink-0" />
                                <span className="text-gray-300 text-sm">+91 9121561555</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaEnvelope className="text-primary flex-shrink-0" />
                                <span className="text-gray-300 text-sm">sunriseagriresorts@yahoo.com</span>
                            </div>
                        </div>
                    </div>

                    {/* Amenities */}
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-primary">Top Amenities</h4>
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3">
                                <FaSwimmingPool className="text-primary flex-shrink-0" />
                                <span className="text-gray-300 text-sm">Swimming Pool</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaWifi className="text-primary flex-shrink-0" />
                                <span className="text-gray-300 text-sm">Free WiFi</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaUtensils className="text-primary flex-shrink-0" />
                                <span className="text-gray-300 text-sm">Food Delivery</span>
                            </div>
                        </div>
                    </div>

                    {/* Social & Quick Links */}
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-primary">Follow Us</h4>
                        <div className="space-y-3">
                            <a
                                href="https://www.instagram.com/sunrise_resorts_s.kota/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center space-x-3 text-gray-300 hover:text-primary transition-colors duration-200"
                            >
                                <FaInstagram className="text-xl" />
                                <span className="text-sm">@sunrise_resorts_s.kota</span>
                            </a>
                        </div>
                        <div className="pt-4">
                            <h5 className="text-sm font-semibold text-gray-400 mb-2">Quick Links</h5>
                            <div className="space-y-1">
                                <a href="/book-room" className="block text-gray-300 hover:text-primary text-sm transition-colors duration-200">Book Now</a>
                                <a href="/gallery" className="block text-gray-300 hover:text-primary text-sm transition-colors duration-200">Gallery</a>
                                <a href="/contact" className="block text-gray-300 hover:text-primary text-sm transition-colors duration-200">Contact</a>
                                <a href="/services" className="block text-gray-300 hover:text-primary text-sm transition-colors duration-200">Rooms & Pricing</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-8 text-center">
                    <p className="text-gray-400 text-sm">
                        &copy; 2025 Sunrise Agri Resorts. All rights reserved. | Designed with ❤️ for your perfect getaway
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;